export enum AuctionType {
    Auction = 'Auction',
    AuctionBin = 'AuctionBin',
    PureBin = 'PureBin',
    ShopItem = 'ShopItem'
}

export enum ShippingOptionProvider {
    PostNordParcel = 'PostNordParcel',
    SchenkerPrivpak = 'SchenkerPrivpak',
    Takeaway = 'Takeaway',
    NotSpecified = 'NotSpecified',
    TakeawayOnly = 'TakeawayOnly'
}

export type ShippingOption = {
    type: ShippingOptionProvider;
    cost: number;
};

export type Attribute = {
    name: string;
    values: string[];
};

export type ItemDto = {
    itemId: number;
    price: number;
    shortDescription: string;
    imageUrl: string;
    imageSecondaryUrl: string;
    imageHeight: number;
    imageWidth: number;
    itemUrl: string;
    itemType: AuctionType;
    totalBids: number;
    startDate: string;
    endDate: string;
    isActive: boolean;
    categoryId: number;
    buyNowPrice: number;
    reservedPriceReached: boolean;
    discountRate: number;
    priceBeforeDiscount: number;
    sellerAlias: string;
    sellerMemberId: number;
    shippingOptions: ShippingOption[];
    hasFreeShipping: boolean;
    displayHighlighted: boolean;
    onDisplay: boolean;
    attributes: Attribute[];

    reservePriceReached: boolean;
    sellerDsrAverage: number;
    imageNormalSizeUrl: string;
    imageSecondaryGallerySizeUrl: string;

    /* Currently only used in Wish list */
    isOverbidden: boolean;
    isLeading: boolean;
    isWinner: boolean;
};
